export default __webpack_public_path__ + "static/media/laptop-lady.2d42325e.jpeg";